export default "__VITE_ASSET__B15Sq0rw__"